import { Component } from '@angular/core';
import { NavigationService } from 'app/utils/navigation/navigation.service';

@Component({
    moduleId: module.id,
    selector: 'accident-cover',
    templateUrl: './_cover.component.html',
    styleUrls: ['./_cover.component.less', '../../../../../styles/app/covers.less'],
})
export class CoverComponent {
    constructor(public navigationService: NavigationService) {}
}
